import moment from 'moment';
import Config from 'config';
import {v4 as uuidV4} from 'uuid';
import SearchTracking from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import TravelDistanceAPI from 'api/travel-distance';
import {getTransientFacilities} from 'search-v2/search-api';
import {getSearchLimits} from 'utils/search-limits';
import {notify} from 'notification/notification-actions';

export const SPOTS_GET_TRANSIENT_V2 = 'SPOTS_GET_TRANSIENT_V2';
export const SPOTS_GET_TRAVEL_DISTANCES_V2 = 'SPOTS_GET_TRAVEL_DISTANCES_V2';

export const loadSpotsTransientV2 = ({
    searchTrackingAction,
    locationContext,
    mapCenter,
    mapBounds,
    eventId,
}) => {
    return (dispatch, getState) => {
        const prevState = getState();
        const searchRequestState = prevState.searchRequest;
        const {
            latitude,
            longitude,
            starts,
            ends,
            rebook_reservation_id: rebookId,
        } = searchRequestState;
        const userState = prevState.user;
        const {
            data: {isAdmin},
        } = userState;
        const timezone = prevState.city.data.timezone;
        const segmentId = SegmentUtils.getAnonymousId();

        SearchTracking.updateAction(searchTrackingAction);
        const {
            sessionUUID,
            searchUUID,
            actionUUID,
            action,
        } = SearchTracking.getValues();

        const {resultLimit, maxDistance} = getSearchLimits({
            locationContext,
            mapCenter,
            mapBounds,
        });

        /* eslint-disable camelcase */
        return dispatch({
            type: SPOTS_GET_TRANSIENT_V2,
            payload: getTransientFacilities(
                {
                    ...(mapCenter
                        ? {
                              origin_lat: latitude,
                              origin_lon: longitude,
                              lat: mapCenter.latitude,
                              lon: mapCenter.longitude,
                          }
                        : {
                              lat: latitude,
                              lon: longitude,
                          }),
                    starts: moment(starts).format(
                        Config.craigApiDateTimeFormat
                    ),
                    ends: moment(ends).format(Config.craigApiDateTimeFormat),
                    show_unavailable: isAdmin,
                    page_size: resultLimit,
                    max_distance_meters: maxDistance,
                    session_uuid: sessionUUID,
                    search_id: searchUUID,
                    action_id: actionUUID,
                    action,
                    segment_id: segmentId,
                },
                {
                    eventId,
                    timezone,
                    rebookId,
                }
            ).then(response => {
                // eslint-disable-next-line no-console
                console.log(response);

                return {
                    results: response,
                };
            }),
        }).catch(error => {
            SegmentUtils.track({
                event: 'Error Message Displayed',
                properties: {
                    'error message': 'Error fetching spots',
                    'error screen': 'search',
                    'error action': 'fetching spots',
                },
            });

            dispatch(
                notify({
                    id: uuidV4(),
                    type: 'error',
                    message: 'Error fetching spots',
                })
            );

            return {
                error: error?.data,
            };
        });
        /* eslint-enable camelcase */
    };
};

export const loadTravelDistancesV2 = spotCoordinates => {
    return (dispatch, getState) => {
        const searchRequestState = getState().searchRequest;
        const destination = {
            latitude: searchRequestState.latitude,
            longitude: searchRequestState.longitude,
        };

        return dispatch({
            type: SPOTS_GET_TRAVEL_DISTANCES_V2,
            payload: TravelDistanceAPI.getTravelDistances({
                destination,
                spotCoordinates,
                isDriving: false,
            })
                .then(travelDistanceResults => {
                    return {
                        results: travelDistanceResults,
                    };
                })
                .catch(emptyResults => {
                    return {
                        results: emptyResults,
                    };
                }),
        });
    };
};

export const loadTransientSpotAndTravelDistances = ({
    searchTrackingAction,
    locationContext,
    mapCenter,
    mapBounds,
    eventId,
}) => {
    return (dispatch, getState) => {
        return dispatch(
            loadSpotsTransientV2({
                searchTrackingAction,
                locationContext,
                mapCenter,
                mapBounds,
                eventId,
            })
        ).then(() => {
            const allSpots = getState().spots.data;
            const spotCoordinates = allSpots.slice(0, 10).map(spot => {
                const primaryAddress = spot.addresses[0];

                return {
                    spotId: spot.spotId,
                    latitude: primaryAddress.latitude,
                    longitude: primaryAddress.longitude,
                };
            });

            return dispatch(loadTravelDistancesV2(spotCoordinates));
        });
    };
};
